import { Controller, FieldError } from "react-hook-form";

type TextareaProps = {
  name: string;
  label?: string;
  error?: FieldError | any;
  isDisabled?: boolean;
  control: any;
  rules?: any;
  htmlFor?: string;
  defaultValue?: string;
};
interface SharedTextareaProps extends Omit<TextareaProps, "ref" | "onChange"> {
  control: any;
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  rules?: any;
  label?: string;
  id: string;
  error?: FieldError | any;
  htmlFor?: string;
  defaultValue?: string;
  placeholder?: string;
  type?: string;
}

export function TextareaField({
  error,
  isDisabled = false,
  control,
  name,
  rules,
  label,
  htmlFor,
  defaultValue,
  ...rest
}: SharedTextareaProps) {
  return (
    <div>
      {error ? (
        <div className="block font-normal tmb-1 text-red-400">
          <p>{error.message}</p>
        </div>
      ) : (
        <label
          htmlFor={htmlFor}
          className="block font-normal tmb-1 text-gray-500"
        >
          {label}
        </label>
      )}
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <textarea
              className="block
                    w-full
                    px-3
                    py-1.5
                    my-2
                    text-base
                    h-40
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded
                    transition
                    ease-in-out
                    m-0
                    disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              ref={ref}
              onChange={onChange}
              value={value}
              disabled={isDisabled}
              {...rest}
            />
          );
        }}
      />
    </div>
  );
}
